import bugsData from '@/mockData/bugs.json'

const state = {
    bugs: bugsData,
}

const mutations = {
    ADD_BUG(state, payload) {
        state.bugs.push(payload)
    },
    FILTER_BUGS(state, criterias) {
        state.bugs = bugsData.filter(item => new Date(item.date) > new Date(criterias.dateFrom) && new Date(item.date) < new Date(criterias.dateTo) && item.author.includes(criterias.author) && item.status.includes(criterias.status) && item.type.includes(criterias.type))
    }
}

const actions = {
    addBug({ commit }, form) {
        commit('ADD_BUG', form)
    },
    filterBugs({ commit }, criterias) {
        commit('FILTER_BUGS', criterias)
    }
}

const getters = {
    getData: state => state.bugs
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

